import { cva, type VariantProps } from 'class-variance-authority';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export const textVariants = cva('font-normal', {
  variants: {
    size: {
      xs: 'text-xs leading-[130%]',
      sm: 'text-sm leading-[130%]',
      md: 'text-md leading-[130%]',
      lg: 'text-lg leading-[130%]',
      xl: 'text-xl leading-[130%]',
      '2xl': 'text-2xl leading-[130%]',
      '3xl': 'text-3xl leading-[130%]',
      '4xl': 'text-4xl leading-[130%]',
      '5xl': 'text-5xl leading-[130%]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export function Text({
  size,
  className,
  ...props
}: ComponentProps<'p'> & VariantProps<typeof textVariants>): JSX.Element {
  return (
    <p
      className={cn(
        textVariants({
          size,
          className,
        }),
      )}
      {...props}
    />
  );
}
